const envNames = {
  testing: 'testing',
  staging: 'staging',
  production: 'production',
};

const CDN_URL = 'https://cdn.clinch.co';

export {CDN_URL, envNames};
